<template>
  <div v-if="computedMarked" v-html="computedMarked" />
</template>

<script setup lang="ts">
import { marked, type RendererObject } from 'marked'

const props = defineProps<{
  md: string | undefined
}>()

const renderer: RendererObject = {
  heading({ tokens, depth }) {
    const text = this.parser.parseInline(tokens)

    return text ? `<h${depth}>${text}</h${depth}>` : false
  },
}

marked.use({ renderer })

const computedMarked = computed(() => (props.md ? marked.parse(props.md) : ''))
</script>
